export enum HttpStatus {
    OK = 200,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDEN = 403,
    NOT_FOUND = 404,
    INTERNAL_SERVER_ERROR = 500,
}

export enum HttpStatusMsg {
    EMAIL_EXISTS = 'EMAIL_EXISTS',
    WRONG_EMAILPASS = 'WRONG_EMAILPASS',
    CONFIRM_EMAIL = 'CONFIRM_EMAIL',
    EMAIL_NOT_APPROVED = 'EMAIL_NOT_APPROVED',
    LOCKOUT = 'LOCKOUT',
    DISABLED = 'DISABLED',
    INVALID_TOKEN = 'INVALID_TOKEN',
    MISSING_ORG = 'MISSING_ORG',
}

export enum InviteOrgStatus {
    INVITED = 1,
    REVOKED = 2,
    ACTIVE = 3,
    INACTIVE = 4,
    SUSPENDED = 5
}

export enum SocialPlatforms {
    GOOGLE = 'GOOGLE',
    FACEBOOK = 'FACEBOOK',
    LINKEDIN = 'LINKEDIN'
}

export enum PeriodEndAction {
    NONE = 0,
    DOWNGRADE = 1,
    CANCEL = 2,
}

export enum MedicalDataDownloadType {
    LIMITED,
    FULL,
}

export enum WorkerJobStatus {
    InQueue = 0,
    InProgress = 1,
    Complete = 2,
    Failed = 3,
    Cancelled = 4,
}

export enum JustintimeStatus {
    DATA_INCOMPLETE = 'data_incomplete',
    DATA_COMPLETE = 'data_complete',
    ADD_NPIS = 'add_npis'
}

export enum JobSteps {
    Parsing = 0,
    Aggregation = 1,
    Import = 2,
}

export enum MedicalType {
    RATES,
    PROVIDERS,
    REPORT,
    NETWORK,
    COMPARE,
    PROFORMA,
    PROVIDER_OVERLAP
}

export enum JobType {
    DOWNLOAD_RATES = 'medical_data_download_rates',
    DOWNLOAD_NPIS = 'medical_data_download_npis',
    SALES_REPORT = 'sales_report_request'
}

export enum AliasType {
    PAYERS = 0,
    SERVICE_CODES = 1,
}

export enum AssociatedType {
    PAYER = 0,
    BUSINESS = 1
}

export enum FilterElement {
    None,
    Address,
    Associated,
    Npi,
    Payer,
    Taxonomy
}

export enum SubscriptionPlanType {
    Annualy = 1,
    Monthly = 2,
}

export enum SubscriptionDataDimension {
    Specific_States = 1,
    National = 2,
}

// Values match the snake_case strings the API serializes the C# TicketStatus enum to.
export enum TicketStatus {
    Open = 'open',
    InReview = 'in_review',
    ReportedToPayer = 'reported_to_payer',
    AdditionalClarificationNeeded = 'additional_clarification_needed',
    Resolved = 'resolved',
    Closed = 'closed',
}
